<div class="warehouse-card-page">
  <header class="page-header">
    <div>
      <h2>{{ pageTitle }}</h2>
      <p *ngIf="warehouse">Склад #{{ warehouse.id }}</p>
      <p *ngIf="!warehouseId">Заполните основные данные нового склада</p>
    </div>

    <button mat-stroked-button type="button" routerLink="/warehouse/list">
      <mat-icon>arrow_back</mat-icon>
      К списку
    </button>
  </header>

  <mat-card class="form-card">
    <mat-progress-bar *ngIf="loading || saving" mode="indeterminate"></mat-progress-bar>

    <form [formGroup]="warehouseForm" (ngSubmit)="submit()">
      <div class="form-content">
        <h3>Основное</h3>

        <mat-form-field appearance="outline">
          <mat-label>Название склада</mat-label>
          <input
            matInput
            formControlName="description"
            autocomplete="off"
            placeholder="Например, Основной склад"
          />
          <mat-error *ngIf="warehouseForm.controls.description.hasError('required')">
            Введите название
          </mat-error>
        </mat-form-field>

        <app-city-selector [control]="cityControl"></app-city-selector>
        <div class="field-hint">Выберите город из справочника</div>
      </div>

      <div class="form-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="loading || saving">
          <mat-icon>save</mat-icon>
          {{ warehouseId ? 'Сохранить изменения' : 'Создать склад' }}
        </button>
        <button mat-stroked-button type="button" routerLink="/warehouse/list" [disabled]="saving">
          Отмена
        </button>
      </div>
    </form>
  </mat-card>
</div>
